import React from "react";

const DownLoadIcon = (props) => {
  return (
    <svg
      style={{ marginRight: 10 }}
      width="13"
      height="18"
      viewBox="0 0 13 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 16.7085C12.25 17.0249 12.0149 17.2864 11.7098 17.3278L11.625 17.3335L0.788249 17.3335C0.443082 17.3335 0.163249 17.0537 0.163249 16.7085C0.163249 16.3921 0.398416 16.1306 0.703499 16.0892L0.788249 16.0835L11.625 16.0835C11.9702 16.0835 12.25 16.3633 12.25 16.7085ZM10.7469 9.53942L10.817 9.59992C11.0388 9.82183 11.059 10.1691 10.8774 10.4137L10.8169 10.4838L6.65217 14.6477C6.43042 14.8694 6.08342 14.8897 5.83875 14.7083L5.76867 14.6479L1.59908 10.4841C1.35483 10.2402 1.35458 9.84442 1.5985 9.60017C1.82025 9.37817 2.16742 9.35775 2.41225 9.53908L2.48242 9.59958L5.58 12.692L5.57925 1.29199C5.57925 0.975575 5.81433 0.714084 6.11942 0.672692L6.20425 0.666992C6.52067 0.666992 6.78208 0.902117 6.8235 1.20718L6.82925 1.29199L6.83 12.7028L9.9331 9.59983C10.155 9.378 10.5022 9.35783 10.7469 9.53942L10.817 9.59992L10.7469 9.53942Z"
        fill="#0358A7"
      />
    </svg>
  );
};

export default DownLoadIcon;
